<template>
  <v-container style="width: 100%;">
    <v-layout justify-space-between>
      <h1>Center of Availability</h1>
    </v-layout>
    <v-layout justify-center py-3 row wrap>
      <v-flex xs12 md10 xl8 py-3>
        <SimpleCard>
          <v-layout pa-2 column>
            <h3>Center of Availability</h3>
            <p>
              <br />Click a place on the map to move the marker representing the center of your fleets availability.
            </p>
            <p>This point will be used to determine estimated dispatch times for your bookings, assuming the driver must travel from approximately this location.</p>
          </v-layout>
        </SimpleCard>
      </v-flex>
      <v-flex xs12 md10 xl8 py-3>
        <SimpleCard>
          <v-layout pa-2 column>
            <AreaPolygonMap ref="areaMap" :height="600"></AreaPolygonMap>
            <v-layout pt-3 row></v-layout>
          </v-layout>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import AreaPolygonMap from "@/components/widget/AreaPolygonMap.vue";
import SimpleCard from "@/components/widget/SimpleCard.vue";

import qs from "qs";
import axios from "axios";
import { setTimeout } from "timers";
axios.defaults.withCredentials = true;

export default {
  name: "operating_regions",
  components: {
    AreaPolygonMap,
    SimpleCard
  },
  data: function() {
    return {
      marker: null
    };
  },
  mounted: function() {
    setTimeout(this.getCenter, 300);
    setTimeout(this.addListener, 300);
  },
  methods: {
    getCenter: async function() {
      var addMarker = this.addMarker;
      try {
        var url = `${this.$store.state.apiUrl}/availability_center/get`;

        let response = await axios.get(url, {
          params: {}
        });

        if (response.data.error == "not_found") {
          throw response.data.error;
        } else {
          var latLng = response.data.center_location;
          addMarker({ lat: latLng.lat, lng: latLng.lon });
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    updateCenterLocation: async function(latLng) {
      var url = `${
        this.$store.state.apiUrl
      }/availability_center/update?lat=${latLng.lat()}&lon=${latLng.lng()}`;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {})
        .catch(function(err) {
          alert("Error " + err);
        });
    },
    addListener: function() {
      var map = this.$refs.areaMap.map;
      var addMarker = this.addMarker;

      var updateCenterLocation = this.updateCenterLocation;

      google.maps.event.addListener(map, "click", function(event) {
        addMarker(event.latLng);
        updateCenterLocation(event.latLng);
      });
    },
    addMarker: function(latLng) {
      if (this.marker != null) {
        this.marker.setMap(null);
      }

      var map = this.$refs.areaMap.map;

      this.marker = new google.maps.Marker({
        position: latLng,
        map: map
      });
      map.panTo(latLng);
    }
  }
};
</script>
